const updates = [
  { date: '2026.07.30', title: '《星辰大海》第二季定档预告发布', tag: '新剧', desc: '年度科幻巨制续作，特效全面升级，备受瞩目。' },
  { date: '2026.07.28', title: '白云视频播放器内核升级至v3.2', tag: '优化', desc: '解码效率提升30%，4K视频加载速度更快。' },
  { date: '2026.07.25', title: '暑期档热门综艺《欢乐喜剧人》回归', tag: '综艺', desc: '新一季笑星云集，首期播放量破千万。' },
  { date: '2026.07.22', title: '「悬疑剧场」专区全新上线', tag: '功能', desc: '聚合全网高分悬疑剧集，一站式追剧体验。' },
  { date: '2026.07.18', title: '动漫频道新增200+正版番剧', tag: '更新', desc: '覆盖热血、治愈、奇幻等全类型动漫资源。' },
  { date: '2026.07.15', title: 'AI智能推荐算法全面优化', tag: '技术', desc: '基于观影偏好精准推荐，发现更多心头好。' },
  { date: '2026.07.10', title: '《古剑传说》全网热度突破500万', tag: '热播', desc: '古装仙侠大剧持续霸榜，口碑与热度双丰收。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-flashlight-line"></i>
            <span className="whitespace-nowrap">实时快讯</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">最新动态</h2>
          <p className="mt-2 text-sm text-foreground-500">平台最新内容与功能更新，保持同步</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, idx) => (
              <div key={idx} className={`relative pb-8 ${idx === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="p-4 rounded-xl bg-background-50 border border-background-200/60">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{item.tag}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}